/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyValueGuidModel } from '../../models/key-value-guid-model';

export interface DashboardClientListPublisherIdGet$Json$Params {
  publisherId: string;
}

export function dashboardClientListPublisherIdGet$Json(http: HttpClient, rootUrl: string, params: DashboardClientListPublisherIdGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueGuidModel>>> {
  const rb = new RequestBuilder(rootUrl, dashboardClientListPublisherIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('publisherId', params.publisherId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<Array<KeyValueGuidModel>>;
    })
  );
}

dashboardClientListPublisherIdGet$Json.PATH = '/Dashboard/ClientList/{publisherId}';
